import SynAff from './lib/synaff';
export default SynAff;



// WEBPACK FOOTER //
// ../node_modules/@cube/synaff/src/index.js